import { useId } from 'react';
import cn from '../../utils/cn';

export type SelectOption = {
  value: string | number;
  label: string;
};

export type SelectProps = {
  label?: string;
  options: SelectOption[];
  value: string | number;
  setValue: (value: string) => void;
  className?: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function Select({ label, options, value, setValue, className }: SelectProps) {
  const id = useId();

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label htmlFor={id} className="text-sm font-bold">
          {label}
        </label>
      )}

      <select
        id={id}
        name={id}
        className="block w-full rounded-lg border py-1.5 pl-3 pr-10 focus:border-brand-500"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
